export default __webpack_public_path__ + "static/media/ppairings.7b8b73f0.jpg";